import { number, object, string } from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import StarRating from './StarRating';
import Avatar from 'react-avatar';
import { FaQuoteLeft } from 'react-icons/fa';

export default function SiteReview({ reviewData, width, symbol }) {
    return (<a
        href={reviewData.url}
        target={'_blank'}
        rel={'noreferrer noopener'}
    >
        <div
            className={'site-review'}
            style={{
                width: `${width}${symbol}`,
            }}>
            <div
                className={'site-review--message'}>
                <FaQuoteLeft
                    className={'site-review--message-icon'}
                    color={'var(--primary-color)'}
                    size={'15px'} />
                {reviewData.message ?? 'No feedback given.'}
            </div>
            <div
                className={'site-review--author-panel'}>
                <Row
                    className={'site-review--data-row'}>
                    <Col
                        className={'site-review--left-col'}>
                        <span
                            className={'site-review--author-link'}
                        >{reviewData.name}</span>
                        <span
                            style={{
                                whiteSpace: 'nowrap',
                                color: 'black',
                            }}>
                            <StarRating
                                rating={reviewData.stars} />
                        </span>
                    </Col>
                    <Avatar
                        name={reviewData.name}
                        color={'#818181'}
                        size={'50px'}
                        round={'2.5px'} />
                </Row>
            </div>
        </div>
    </a>);
}

SiteReview.propTypes = {
    reviewData: object,
    width: number,
    symbol: string,
};